import { render, staticRenderFns } from "./InstitutionalReportLink.vue?vue&type=template&id=46c10e5f&"
import script from "./InstitutionalReportLink.vue?vue&type=script&lang=js&"
export * from "./InstitutionalReportLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports